import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();

export const nativePlatform = () => Capacitor.getPlatform();

export const isAndroid = () => nativePlatform() === 'android';

export const isIOS = () => nativePlatform() === 'ios';
